export const gastoenSalud = [
    {
        "item" : "I. I. MARCO REGULATORIO",
         "documento_array" : 
         [
            {
                "nombre_documento": "Ley de Transparencia del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/1 Ley de Transparencia y Acceso a la Informacion Publica para el Estado de Hidalgo.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Ley de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/2 Ley de Salud para el Estado de Hidalgo.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Reglamento Interior de la Secretaría de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/3 Reglamento Interior Secretaria Salud.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Estatuto Orgánico de los Servicios de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"Vigente",
                     "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/4 Estatuto Orgánico de SSH.pdf"
                  },
                  {
                     "file_item_nombre":"Por Aprobarse en Junta de Gobierno",
                     "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/4-1 Estatuto Organico de SSH Por Aprobarse.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Decreto de Creación del OPD encargado del Sector (Servicios de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/5 Decreto de creacion Servicios de Salud de Hidalgo.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "ACUERDOS Y CONVENIOS DE COORDINACIÓN ENTRE EL ESTADO Y LA SECRETARÍA DE SALUD FEDERAL",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":""
                  }
                ],
                "hijos" : 
                [
                    {
                        "nombre_documento": "Acuerdo Marco de Coordinación para la concurrencia en la Prestación de Servicios en materia, entre la Secretaria de Salud Federal y el Gobierno Estatal",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/6 Acuerdo Marco de coordinacion para la concurrencia.pdf"
                          }
                        ]
                    },
                    {
                        "nombre_documento": 'Acuerdo de adhesión o en su caso de Coordinación celebrado entre el Instituto de Salud para el Bienestar "INSABI" y el Gobierno del Estado',
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/7 Acuerdo de Coordinacion INSABI.pdf"
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Convenio especifico en materia de ministración de subsidios para el Fortalecimiento de Acciones de Salud en las Entidades Federativas CONVENIO-AFASPE-HGO/2021",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/8 Convenio en materia de ministracion.pdf"
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Modificatorio 01-CM-AFASPE-HGO2021",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/9 01-CM-AFASPE-HGO2021.pdf"
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Modificatorio 02-CM-AFASPE-HGO-2021",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/10 02-CM-AFASPE-HGO-2021.docx"
                          },
                         {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/10 02-CM-AFASPE-HGO-2021.pdf"
                          },
                        ]
                    },
                    {
                        "nombre_documento": "CRESCA-CONADIC-HGO-001/2021",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/11 CRESCA-CONADIC.pdf"
                          },
                        ]
                    },
                    {
                        "nombre_documento": "DGCES-CETR-HGO-G005-2021",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/12 DGCES-CETR-HGO-G005-2021.docx"
                          },
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/12 DGCES-CETR-HGO-G005-2021.pdf"
                          },
                        ]
                    },
                    {
                        "nombre_documento": "CCMTI-005-CENSIDA-HIDALGO-2020-2021",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/13 CENSIDA.docx"
                          },
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/13 CENSIDA.pdf"
                          },
                        ]
                    },
                    {
                        "nombre_documento": "DE COLABORACIÓN INSABI PSP-E023-2021-HGO-13",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/14 COLABORACION INSABI PSP-E023-2021-HGO-13.pdf"
                          },
                        ]
                    },
                    {
                        "nombre_documento": "COFEPRIS-CETR-HGO.-13-21",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/15 COFEPRIS-CETR-HGO.-13-21..pdf"
                          },
                        ]
                    },
                    {
                        "nombre_documento": 'ANEXO 4 INSABI monto de recursos a transferir y conceptos de gasto del “acuerdo de coordinación para garantizar la prestación gratuita de servicios de salud”',
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":"/contenido/transparencia/gastoensalud/I. MARCO REGULATORIO/16 Anexo 4 INSABI.pdf"
                          },
                        ]
                    },    
                ]
            },
         ]
    },
    {
        "item" : "II. MARCO PROGRAMATICO PRESUPUESTAL",
         "documento_array" : 
         [
            {
                "nombre_documento": "Programa Sectorial en materia de Salud",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/1 Programa Sectorial/Programa Sectorial de Salud.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Programa Institucional de los Servicios de Salud",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/2 Programa Institucional/Programa Institucional.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Programa Operativo Anual o Programa Presupuestal",
                "documento":[
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/3 Programa Operativo Anual/POA 2019.xlsx"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/3 Programa Operativo Anual/POA 2020.xlsx"
                  },
                {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/3 Programa Operativo Anual/POA 2021.xlsx"
                  }
                ]
            },
            {
                "nombre_documento": "Programa (Plan) Anual de Adquisiciones",
                "documento":[
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/4 Programa Anual de adquisiciones/2019.zip"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/4 Programa Anual de adquisiciones/2020.zip"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/4 Programa Anual de adquisiciones/2021.zip"
                  }
                ]
            },
            {
                "nombre_documento": "Acciones especiales generadas por contingencia (Covid-19)",
                "documento":[
            {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/5 Acciones generados por contigencia (Covid-19)/2020.zip"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/5 Acciones generados por contigencia (Covid-19)/2021.zip"
                  }
                ]
            },
            {
                "nombre_documento": "Presupuesto asignado (Ingresos a recibir por cualquier concepto)",
                "documento":[
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/6 Presupuesto asignado/Pto. Egresos Edo. Hidalgo 2019.pdf"
                  },
                 {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/6 Presupuesto asignado/Pto. Egresos Edo. Hidalgo 2020.pdf"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/6 Presupuesto asignado/Pto. Egresos Edo. Hidalgo 2021.pdf"
                  }
                ],
            },
            {
                "nombre_documento": "INFORMACIÓN DE INGRESOS Y EGRESOS DEL SS CON BASE EN LAS NORMAS EMITIDAS POR EL CONAC",
                "documento":[
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/7 Ingresos y egresos CONAC/Ingresos y egresos normas CONAC 2019.zip"
                  },
                 {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/7 Ingresos y egresos CONAC/Ingresos y Egresos normas CONAC 2020.zip"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/7 Ingresos y egresos CONAC/Ingresos y Egresos normas CONAC 2021.zip"
                  }
                ],
                 "hijos" : 
                [
                    {
                        "nombre_documento": "Información adicional a la Iniciativa de Ley de Ingresos",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Calendario de ingresos base mensual",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Información adicional al Proyecto del Presupuesto de Egresos",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Calendario Presupuesto de Egresos base mensual",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                ]
            },
            {
                "nombre_documento" : "Mecanismos de participación ciudadana: Mecanismos para la recepción de opiniones y quejas, así como el mecanismo para ser aval ciudadano",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/II. MARCO PROGRAMATICO PRESUPUESTAL/8 Mecanismos/Mecanismos de participación ciudadana.xlsx"
                  },
                ],
            },  
        ]
    },
    {
        "item" : "III. COSTOS OPERATIVOS",
         "documento_array" : 
         [
            {
                "nombre_documento": "Estructura orgánica de la Secretaría de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/1 Estructura SESA/SESA.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Facultades de cada área de la Secretaría de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/2 Facultades SESA/SESA.pdf"
                  }
                ]
            },
            {
                "nombre_documento": "Estructura orgánica de Servicios de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/3 Estructura SSH/SSH.pdf"
                  },
                ]
            },
            {
                "nombre_documento": "Facultades de cada área de Servicios de Salud del Estado de Hidalgo",
                "documento":[
                  {
                     "file_item_nombre":"Vigente",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/4 Facultades SSH/SSH.pdf"
                  },
                  {
                     "file_item_nombre":"Por Aprobarse en Junta de Gobierno",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/4 Facultades SSH/SSH Por Aprobarse.pdf"
                  },
                ]
            },
            {
                "nombre_documento": "PLAZAS CON BASE EN FORMATOS CONAC",
                "documento":
                [
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/5 Plazas con base en formatos CONAC/2019.zip"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/5 Plazas con base en formatos CONAC/2020.zip"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/5 Plazas con base en formatos CONAC/2021.zip"
                  },
                  {
                     "file_item_nombre":"2022",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/5 Plazas con base en formatos CONAC/2022.zip"
                  },
                  {
                     "file_item_nombre":"2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/5 Plazas con base en formatos CONAC/2023.zip"
                  }
                ],
                "hijos" : 
                [
                    {
                        "nombre_documento": "Formato: Analítico de plazas",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Formato: Honorarios",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Formato: Pagos diferentes al costo asociado a las plazas",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Formato: Pagos retroactivos",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Formato: Personal comisionado",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Formato: Plazas existentes",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Formato: Tabulador",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                    {
                        "nombre_documento": "Formato: Trabajadores con licencia",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          }
                        ]
                    },
                ]

            },
            {
                "nombre_documento": "Personal financiado con el FASSA: Número de plazas por trabajadores (regularizados, eventuales, honorarios y homologados)",
                "documento":[
                  {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/6 Personal financiado con el FASSA/2018.xlsx"
                  },
                 {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/6 Personal financiado con el FASSA/2019.xlsx"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/6 Personal financiado con el FASSA/2020.xlsx"
                  },
                                    {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/6 Personal financiado con el FASSA/2021.xlsx"
                  },
                  {
                     "file_item_nombre":"2022",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/6 Personal financiado con el FASSA/2022.xlsx"
                  },
                  {
                     "file_item_nombre":"2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/6 Personal financiado con el FASSA/2023.xlsx"
                  }
                ],
            },
            {
                "nombre_documento": "Sueldos y salarios de altos funcionarios (Secretario y directores)",
                "documento":[
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/7 Sueldos y salarios altos funcionarios/2019.xlsx"
                  },
                 {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/7 Sueldos y salarios altos funcionarios/2020.xlsx"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/7 Sueldos y salarios altos funcionarios/2021.xlsx"
                  }
                ],
            },
            {
                "nombre_documento" : "Padrón de proveedores",
                "documento":[
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/8 Proveedores/Proveedores.xlsx"
                  },
                ],
            },
            {
                "nombre_documento" : "Padrón de proveedores de servicios de subrogación",
                "documento":[
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/9 Proveedores de Subrogación/Proveedores subrogacion.xlsx"
                  },
                ],
            },
            {
                "nombre_documento" : "Servicios disponibles",
                "documento":[
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"https://ruts.hidalgo.gob.mx/?undefined&dependencia=Secretar%C3%ADa%20de%20Salud"
                  },
                ],
            },
            {
                "nombre_documento" : "Inventario de bienes muebles en posesión",
                "documento":[
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/11 Inv. Muebles/Inv. B. Muebles.xlsx"
                  },
                ],
            }, 
            {
                "nombre_documento" : "Inventario de bienes inmuebles en posesión",
                "documento":[
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/12 Inv. Inmuebles/Inv. B. Inmuebles.xlsx"
                  },
                ],
            },
            {
                "nombre_documento" : "Control de Inventario de medicamentos",
                "documento":[
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/13 Inv. Medicamentos/Inv. medicamentos.zip"
                  },
                ],
            },
            {
                "nombre_documento": "ADQUISICIONES DE BIENES Y SERVICIOS DEL SS",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":""
                  }
                ],
                 "hijos" : 
                [
                    {
                        "nombre_documento": "A: Licitación pública y/o invitación restringida",
                        "documento":[
                          {
                             "file_item_nombre":"2019",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/14 Adquisiciones de Bienes y Servicios/2019/1 Licitación.xlsx"
                          },
                          {
                             "file_item_nombre":"2020",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/14 Adquisiciones de Bienes y Servicios/2019/1 Licitacion.xlsx"
                          },
                         {
                             "file_item_nombre":"2021",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/14 Adquisiciones de Bienes y Servicios/2019/1 Licitación.xlsx"
                          }
                        ]
                    },
                    {
                        "nombre_documento": "B: Adjudicación directa",
                        "documento":[
                          {
                             "file_item_nombre":"2019",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/14 Adquisiciones de Bienes y Servicios/2019/2 Directa.xlsx"
                          },
                          {
                             "file_item_nombre":"2020",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/14 Adquisiciones de Bienes y Servicios/2020/2 Directa.xlsx"
                          },
                         {
                             "file_item_nombre":"2021",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/14 Adquisiciones de Bienes y Servicios/2021/2 Directa.xlsx"
                          }
                        ]
                    }              
                ]
            },
            {
                "nombre_documento": "ADJUDICACIÓN DE OBRA PÚBLICA DEL SS",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":""
                  }
                ],
                 "hijos" : 
                [
                    {
                        "nombre_documento": "A: Licitación pública y/o invitación restringida",
                        "documento":[
                          {
                             "file_item_nombre":"2019",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/15 Adjudicacion de ObraPublica/2019/1 Licitación.xlsx"
                          },
                          {
                             "file_item_nombre":"2020",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/15 Adjudicacion de ObraPublica/2020/1 Licitacion.xlsx"
                          },
                         {
                             "file_item_nombre":"2021",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/15 Adjudicacion de ObraPublica/2021/1 Licitacion.xlsx"
                          }
                        ]
                    },
                    {
                        "nombre_documento": "B: Adjudicación directa",
                        "documento":[
                          {
                             "file_item_nombre":"2019",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/15 Adjudicacion de ObraPublica/2019/2 Directa.xlsx"
                          },
                          {
                             "file_item_nombre":"2020",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/15 Adjudicacion de ObraPublica/2019/2 Directa.xlsx"
                          },
                         {
                             "file_item_nombre":"2021",
                             "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/15 Adjudicacion de ObraPublica/2019/2 Directa.xlsx"
                          }
                        ]
                    }              
                ]
            },
            {
                "nombre_documento" : "Compras realizadas con motivo de Covid-19",
                "documento":[
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/16 Compras Covid/2020/Gasto Covid al 31-12-2020.xlsx"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/16 Compras Covid/2021/Gasto covid 2021.xlsx"
                  },
                ],
            },
            {
                "nombre_documento" : "Sistema Integral de Trazabilidad y Seguimiento de Procesos",
                "documento":[
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/III. COSTOS OPERATIVOS/17 Sistema Integral de Trazabilidad y Seguimiento de Procesos/Manual de usuario Trazabilidad.pdf"
                  },
                ],
            },   
        ]
    },
    {
        "item" : "IV. RENDICION DE CUENTAS",
         "documento_array" : 
        [
            {
                "nombre_documento": "Informes de actividades",
                "documento":[
                  {
                     "file_item_nombre":"2017",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/1 Informes de actividades/COMPARECENCIA 2017.pdf"
                  },
                                    {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/1 Informes de actividades/COMPARECENCIA 2018.pdf"
                  },
                                    {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/1 Informes de actividades/COMPARECENCIA 2019.pdf"
                  },
                                    {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/1 Informes de actividades/COMPARECENCIA 2020.pdf"
                  },
                                    {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/1 Informes de actividades/COMPARECENCIA 2021.pdf"
                  },
                  {
                     "file_item_nombre":"2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/1 Informes de actividades/COMPARECENCIA 2023.pdf"
                  },
                  {
                     "file_item_nombre":"2024",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/1 Informes de actividades/COMPARECENCIA 2024.pdf"
                  }
                ],
            },
            {
                "nombre_documento": "INFORMACIÓN CONTABLE Y PRESUPUESTAL",
                "documento":[
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/2 Información Contable y Presupuestal/2019.zip"
                  },
                 {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/2 Información Contable y Presupuestal/2020.zip"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/2 Información Contable y Presupuestal/2021.zip"
                  },
                  {
                     "file_item_nombre":"2022",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/2 Información Contable y Presupuestal/2022.zip"
                  },
                  {
                     "file_item_nombre":"2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/2 Información Contable y Presupuestal/2023.zip"
                  },
                  {
                     "file_item_nombre":"2024",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/2 Información Contable y Presupuestal/2024.zip"
                  },
       
                ],
                "hijos" : 
                [
                    {
                        "nombre_documento": "Estado de actividades",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Estado de situación financiera",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Estado analítico de la deuda y otros pasivos",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Estado de cambios en la situación financiera",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Notas a los estados financieros",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Analítico de ingresos por rubro y fuente de financiamiento",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Analíticos del ejercicio del presupuesto de egresos por clasificaciones: Económica",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Analíticos del ejercicio del presupuesto de egresos por clasificaciones: Administrativa",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Analíticos del ejercicio del presupuesto de egresos por clasificaciones: Funcional",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Analíticos del ejercicio del presupuesto de egresos por clasificaciones: Por capítulo del gasto",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                ]
            },
            {
                "nombre_documento": "CUMPLIMIENTO DE LA LEY DE DISCIPLINA FINANCIERA DEL OPD (SERVICIOS DE SALUD)",
                "documento":[
                  {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/3 Cumplimiento de la Ley de Disciplina Financiera/2018.zip"
                  },
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/3 Cumplimiento de la Ley de Disciplina Financiera/2019.zip"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/3 Cumplimiento de la Ley de Disciplina Financiera/2020.zip"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/3 Cumplimiento de la Ley de Disciplina Financiera/2021.zip"
                  },
                  {
                     "file_item_nombre":"2022",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/3 Cumplimiento de la Ley de Disciplina Financiera/2022.zip"
                  },
                  {
                     "file_item_nombre":"2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/3 Cumplimiento de la Ley de Disciplina Financiera/2023.zip"
                  },
                  {
                     "file_item_nombre":"2024",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/3 Cumplimiento de la Ley de Disciplina Financiera/2024.zip"
                  }

                ],
                "hijos" : 
                [
                    {
                        "nombre_documento": "Formato 4. Balance Presupuestario - LDF",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Formato 5. Estado Analítico de Ingresos detallado - LDF",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Formato 6a. Estado Analitico del Ejercicio del Presupuesto de Egresos Detallado-LDF (Clasificación por Objeto del Gasto)",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Formato 6b. Estado analítico del Ejercicio del Presupuesto de Egresos Detallado-LDF(Clasificación Administrativa)",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Formato 6c. Estado analítico del Ejercicio del Presupuesto de Egresos Detallado-LDF(Clasificación Funcional)",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Formato 6d. Estado analítico del Ejercicio del Presupuesto de Egresos Detallado-LDF (Clasificación de Servicios Personales por Categoría)",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                ]

            },

            {
                "nombre_documento": "Cuenta Pública del OPD Servicios de Salud",
                "documento":[
                  {
                     "file_item_nombre":"2017",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/4 Cuenta Publica/CUENTA PÚBLICA 2017.pdf"
                  },
                  {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/4 Cuenta Publica/CUENTA PÚBLICA 2018.pdf"
                  },
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/4 Cuenta Publica/CUENTA PÚBLICA 2019.pdf"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/4 Cuenta Publica/CUENTA PÚBLICA 2020.pdf"
                  },
                  {
                     "file_item_nombre":"2021",
                    "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/4 Cuenta Publica/CUENTA PÚBLICA 2021.pdf"
                  },
                  {
                     "file_item_nombre":"2022",
                    "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/4 Cuenta Publica/CUENTA PÚBLICA 2022.pdf"
                  }

                ],

            },
            {
                "nombre_documento": "Beneficiarios de las ayudas sociales y acciones implementadas por Covid-19",
                "documento":[
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/5 Beneficiarios/Beneficiarios COVID19 2020.xlsx"
                  },
                  {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/IV. RENDICION DE CUENTAS/5 Beneficiarios/Beneficiarios COVID19 2021.xlsx"
                  },
                ],

            },
        ]
    },
    {
        "item" : "V. EVALUACIÓN DE RESULTADOS",
         "documento_array" : 
        [
            {
                "nombre_documento": "Indicadores de gestión del SS",
                "documento":[
                  {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2018.zip"
                  },
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2019.zip"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2020.zip"
                  },
                 {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2021.zip"
                  },
                  {
                     "file_item_nombre":"2022",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2022.zip"
                  },
                  {
                     "file_item_nombre":"2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2023.zip"
                  },
                  {
                     "file_item_nombre":"2024",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2024.zip"
                  },
                  {
                     "file_item_nombre":"2025",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/1 Indicadores de gestión del SS/2025.zip"
                  }
                ]
            },
            {
                "nombre_documento": "Formato único de aplicación de recursos FASSA",
                "documento":[
                  {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2018.xlsx"
                  },
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2019.xlsx"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2020.xlsx"
                  },
                 {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2021.xlsx"
                  },
                  {
                     "file_item_nombre":"2022",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2022.xlsx"
                  },
                  {
                     "file_item_nombre":"2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2023.xlsx"
                  },
                  {
                     "file_item_nombre":"2024",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2024.xlsx"
                  },
                  {
                     "file_item_nombre":"2025",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/2 Formato único de aplicación de recursos FASSA/4to Trimestre 2025.xlsx"
                  },
                ]
            },
            {
                "nombre_documento": "Informes de resultados de auditorías al ejercicio presupuestal internas y externas",
                "documento":[
                  {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/3 Resultados de auditorías/Informe 2018.xlsx"
                  },
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/3 Resultados de auditorías/Informe 2019.xlsx"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/3 Resultados de auditorías/Informe 2020.xlsx"
                  },
                ]
            },
            {
                "nombre_documento": "Unidades de salud con reconocimiento del Aval ciudadano",
                "documento":[
                  {
                     "file_item_nombre":"2018",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/4 Unidades con reconocimiento Aval ciudadano/Unidades aval ciudadano 2018.xlsx"
                  },
                  {
                     "file_item_nombre":"2019",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/4 Unidades con reconocimiento Aval ciudadano/Unidades aval ciudadano 2019.xlsx"
                  },
                  {
                     "file_item_nombre":"2020",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/4 Unidades con reconocimiento Aval ciudadano/Unidades aval ciudadano 2020.xlsx"
                  },
                 {
                     "file_item_nombre":"2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/4 Unidades con reconocimiento Aval ciudadano/Unidades aval ciudadano 2021.xlsx"
                  },
                ]
            },
            {
                "nombre_documento": "Unidades médicas con alguna certificación de calidad",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/5 Unidades médicas con alguna certificación de calidad/certificación de unidades.xlsx"
                  },

                ]
            },
            {
                "nombre_documento": "Normas de Calidad implementadas para la Gestión en el Sector Salud",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/V. EVALUACIÓN DE RESULTADOS/6 Normas de Calidad/Implementadas para la Gestión en el Sector Salud.xlsx"
                  },

                ]
            },
        ]
    },
    {
        "item" : "VI. ESTADISTICAS",
         "documento_array" : 
        [
            {
                "nombre_documento": "Asignación de recursos por componentes del FASSA",
                "documento":[
                  {
                     "file_item_nombre":"2013-2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/VI. ESTADISTICAS/1 Asignación de recursos  por componentes del FASSA.xlsx"
                  },
                ],
                "hijos" : 
                [
                    {
                        "nombre_documento": "Prestación de servicios de salud a la comunidad",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Prestación de servicios de salud a la persona",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Generación de recursos para la salud",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Rectoría del sistema de salud",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },
                    {
                        "nombre_documento": "Protección Social a la Salud",
                        "documento":[
                          {
                             "file_item_nombre":"",
                             "file_item_url":""
                          },
                        ]
                    },

                ]

            },
            {
                "nombre_documento": "Universo, población por tipo de derechohabiente: con seguridad social, sin seguridad social y no especificado",
                "documento":[
                  {
                     "file_item_nombre":"2013-2022",
                     "file_item_url":"/contenido/transparencia/gastoensalud/VI. ESTADISTICAS/2 Universo de Poblacion por tipo de derechohabiente.xlsx"
                  },
                  {
                     "file_item_nombre":"2013-2023",
                     "file_item_url":"/contenido/transparencia/gastoensalud/VI. ESTADISTICAS/2013-2023.xlsx"
                  },
                  {
                     "file_item_nombre":"2013-2024",
                     "file_item_url":"/contenido/transparencia/gastoensalud/VI. ESTADISTICAS/2013-2024.xlsx"
                  },
                ],    
            },
            {
                "nombre_documento": "Número de muertes maternas de mujeres CON y SIN seguridad social",
                "documento":[
                  {
                     "file_item_nombre":"2013-2021",
                     "file_item_url":"/contenido/transparencia/gastoensalud/VI. ESTADISTICAS/3 Muertes maternas con y sin seguridad.xlsx"
                  },
                ],    
            },
            {
                "nombre_documento": "Estadisticas por Covid-19 en el Estado",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"/contenido/transparencia/gastoensalud/VI. ESTADISTICAS/4 estadisticas.xlsx"
                  },
                ],    
            },
            {
                "nombre_documento": "Liga de acceso a las estadísticas de Cubos dinámicos del SIS",
                "documento":[
                  {
                     "file_item_nombre":"",
                     "file_item_url":"http://www.dgis.salud.gob.mx/contenidos/basesdedatos/BD_Cubos_gobmx.html"
                  },
                ],    
            },
        ]
    }    
]